import React, { useState } from 'react';

function About() {
  const [activeAccordion, setActiveAccordion] = useState('faq-1');

  const toggleAccordion = (id) => {
    setActiveAccordion(activeAccordion === id ? null : id);
  };

  const teamMembers = [
    { name: 'Engineering Team', role: 'R&D Department', image: 'assets/images/team/team-1.webp' },
    { name: 'Manufacturing', role: 'Production Head', image: 'assets/images/team/team-2.webp' },
    { name: 'Quality Control', role: 'QA Department', image: 'assets/images/team/team-3.webp' },
    { name: 'Customer Service', role: 'Support Team', image: 'assets/images/team/team-4.webp' }
  ];

  const testimonials = [
    {
      name: 'Pharmaceutical Manufacturer',
      role: 'Production Manager',
      image: 'assets/images/testimonial/client-1.webp',
      text: "S.D. Pharma Machine's tablet press equipment has significantly improved our production efficiency. The machines are reliable, easy to operate, and deliver consistent quality tablets. Their technical support team is excellent and always available when we need assistance."
    },
    {
      name: 'Generic Drug Company',
      role: 'Plant Head',
      image: 'assets/images/testimonial/client-2.webp',
      text: "We've installed multiple tablet press machines from S.D. Pharma Machine and they have exceeded our expectations. The build quality is outstanding, maintenance is minimal, and the machines comply with all cGMP requirements. Highly recommended for pharmaceutical manufacturing."
    },
    {
      name: 'API Manufacturer',
      role: 'Quality Director',
      image: 'assets/images/testimonial/client-3.webp',
      text: "S.D. Pharma Machine provides excellent pharmaceutical equipment with superior precision and durability. We use their roll compactor and tablet press machines for our production line. The after-sales service is prompt and professional. Great value for investment."
    }
  ];

  const faqs = [
    {
      id: 'faq-1',
      question: 'What pharmaceutical equipment does S.D. Pharma Machine manufacture?',
      answer: "We manufacture a complete range of pharmaceutical machinery including high-speed rotary tablet press machines, single rotary tablet press, roll compactor, tablet coating machines, rapid mixer granulator, fluid bed dryer, multi mill, oscillating granulator, and dust extraction systems. All equipment is designed to meet cGMP standards."
    },
    {
      id: 'faq-2',
      question: 'Do you provide installation and training services?',
      answer: "Yes, we provide complete installation, commissioning, and training services for all our pharmaceutical machines. Our expert technicians will install the equipment at your facility and train your operators on proper operation, maintenance, and troubleshooting procedures."
    },
    {
      id: 'faq-3',
      question: 'What is the warranty period for your machines?',
      answer: "We provide comprehensive warranty coverage for all our pharmaceutical machines. The standard warranty period is 12 months from the date of installation. During this period, we offer free replacement of defective parts and technical support. Extended warranty options are also available."
    },
    {
      id: 'faq-4',
      question: 'Do you provide spare parts and maintenance services?',
      answer: "Yes, we maintain a complete inventory of spare parts for all our machines and provide prompt delivery. Our experienced service engineers are available for on-site maintenance, troubleshooting, and repairs. We also offer Annual Maintenance Contracts (AMC) for hassle-free operations."
    },
    {
      id: 'faq-5',
      question: 'Are your machines cGMP compliant?',
      answer: "Absolutely! All our pharmaceutical machinery is designed and manufactured to comply with current Good Manufacturing Practices (cGMP) guidelines. Our equipment meets international quality standards and regulatory requirements for pharmaceutical manufacturing facilities."
    }
  ];

  return (
    <main id="primary" className="site-main">
      <div className="space-for-header"></div>

      {/* Breadcrumb Section */}
      <section className="tj-page-header section-gap-x" data-bg-image="assets/images/bg/pheader-bg.webp">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="tj-page-header-content text-center">
                <h1 className="tj-page-title">About Us</h1>
                <div className="tj-page-link">
                  <span><i className="fas fa-home"></i></span>
                  <span><a href="/">Home</a></span>
                  <span><i className="fas fa-arrow-right"></i></span>
                  <span><span>About Us</span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-header-overlay" data-bg-image="assets/images/shape/pheader-overlay.png"></div>
      </section>

      {/* Choose Section */}
      <section id="choose" className="tj-choose-section section-gap">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="sec-heading-wrap">
                <span className="sub-title wow fadeInUp" data-wow-delay=".3s">
                  <i className="fas fa-box"></i>Choose the Best
                </span>
                <div className="heading-wrap-content">
                  <div className="sec-heading">
                    <h2 className="sec-title title-anim">
                      Leading Manufacturer of Pharmaceutical <span>Machinery.</span>
                    </h2>
                  </div>
                  <div className="btn-wrap wow fadeInUp" data-wow-delay=".6s">
                    <a className="tj-primary-btn" href="/contact">
                      <span className="btn-text"><span>Request a Call</span></span>
                      <span className="btn-icon"><i className="fas fa-arrow-right"></i></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row row-gap-4 rightSwipeWrap">
            <div className="col-lg-4">
              <div className="choose-box right-swipe">
                <div className="choose-content">
                  <div className="choose-icon">
                    <i className="fas fa-cogs"></i>
                  </div>
                  <h4 className="title">Precision Engineering</h4>
                  <p className="desc">Our pharmaceutical machines are engineered with precision components ensuring consistent performance, accuracy, and reliability in tablet production and granulation processes.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="choose-box right-swipe">
                <div className="choose-content">
                  <div className="choose-icon">
                    <i className="fas fa-certificate"></i>
                  </div>
                  <h4 className="title">cGMP Compliant Equipment</h4>
                  <p className="desc">All our machines meet current Good Manufacturing Practices standards with proper documentation, validation protocols, and regulatory compliance for pharmaceutical manufacturing.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="choose-box right-swipe">
                <div className="choose-content">
                  <div className="choose-icon">
                    <i className="fas fa-tools"></i>
                  </div>
                  <h4 className="title">Complete After-Sales Support</h4>
                  <p className="desc">We provide comprehensive installation, training, maintenance, and spare parts support to ensure your production line runs smoothly with minimal downtime.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="tj-about-section-2 section-gap section-gap-x">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-6 order-lg-1 order-2">
              <div className="about-img-area style-2 wow fadeInLeft" data-wow-delay=".3s">
                <div className="about-img overflow-hidden">
                  <img data-speed=".8" src="assets/images/about/about-5.webp" alt="" />
                </div>
                <div className="box-area style-2">
                  <div className="progress-box wow fadeInUp" data-wow-delay=".3s">
                    <h4 className="title">Quality Metrics</h4>
                    <ul className="tj-progress-list">
                      <li>
                        <h6 className="tj-progress-title">Production Quality</h6>
                        <div className="tj-progress">
                          <span className="tj-progress-percent">95%</span>
                          <div className="tj-progress-bar" data-percent="95"></div>
                        </div>
                      </li>
                      <li>
                        <h6 className="tj-progress-title">Customer Satisfaction</h6>
                        <div className="tj-progress">
                          <span className="tj-progress-percent">98%</span>
                          <div className="tj-progress-bar" data-percent="98"></div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 order-lg-2 order-1">
              <div className="about-content-area">
                <div className="sec-heading">
                  <span className="sub-title wow fadeInUp" data-wow-delay=".3s">
                    <i className="fas fa-box"></i>About S.D. Pharma Machine
                  </span>
                  <h2 className="sec-title title-anim">
                    Leading Manufacturer of Pharmaceutical Machinery with Precision Engineering and Quality <span>Assurance.</span>
                  </h2>
                </div>
              </div>
              <div className="about-bottom-area">
                <div className="mission-vision-box wow fadeInLeft" data-wow-delay=".5s">
                  <h4 className="title">Our Mission</h4>
                  <p className="desc">To manufacture world-class pharmaceutical machinery with precision engineering, cGMP compliance, and exceptional customer support.</p>
                  <ul className="list-items">
                    <li><i className="fas fa-check"></i>Precision Engineering</li>
                    <li><i className="fas fa-check"></i>cGMP Compliant Equipment</li>
                    <li><i className="fas fa-check"></i>Quality Manufacturing</li>
                  </ul>
                </div>
                <div className="mission-vision-box wow fadeInRight" data-wow-delay=".5s">
                  <h4 className="title">Our Vision</h4>
                  <p className="desc">To be India's most trusted pharmaceutical equipment manufacturer, known for innovation, reliability, and customer satisfaction.</p>
                  <ul className="list-items">
                    <li><i className="fas fa-check"></i>Industry Leadership</li>
                    <li><i className="fas fa-check"></i>Continuous Innovation</li>
                    <li><i className="fas fa-check"></i>Customer Trust</li>
                  </ul>
                </div>
              </div>
              <div className="about-btn-area wow fadeInUp" data-wow-delay=".6s">
                <a className="tj-primary-btn" href="/about">
                  <span className="btn-text"><span>Learn More About Us</span></span>
                  <span className="btn-icon"><i className="tji-arrow-right-long"></i></span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-shape-1">
          <img src="assets/images/shape/pattern-2.svg" alt="" />
        </div>
        <div className="bg-shape-2">
          <img src="assets/images/shape/pattern-3.svg" alt="" />
        </div>
      </section>

      {/* Client Section */}
      <section className="tj-client-section client-section-gap-2 wow fadeInUp" data-wow-delay=".4s">
        <div className="container-fluid client-container">
          <div className="row">
            <div className="col-12">
              <div className="client-content">
                <h5 className="sec-title">
                  Trusted by <span className="client-numbers">500+</span> Pharmaceutical Companies with <span className="client-text">S.D. Pharma Machine</span>
                </h5>
              </div>
              <div className="swiper client-slider client-slider-1">
                <div className="swiper-wrapper">
                  {[1, 2, 3, 4, 5, 6].map((num) => (
                    <div key={num} className="swiper-slide client-item">
                      <div className="client-logo">
                        <img src={`assets/images/brands/brand-${num}.webp`} alt="" />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="tj-testimonial-section-2 section-bottom-gap">
        <div className="container">
          <div className="row row-gap-3">
            <div className="col-lg-6 order-lg-2">
              <div className="testimonial-img-area wow fadeInUp" data-wow-delay=".3s">
                <div className="testimonial-img">
                  <img src="assets/images/testimonial/testimonial-img.webp" alt="" />
                  <div className="sec-heading style-2">
                    <h2 className="sec-title title-anim">Hear from Our <span>Customer.</span></h2>
                  </div>
                </div>
                <div className="box-area">
                  <div className="rating-box wow fadeInUp" data-wow-delay=".5s">
                    <h2 className="title">4.9</h2>
                    <div className="rating-area">
                      <div className="star-ratings">
                        <div className="fill-ratings" style={{ width: '100%' }}>
                          <span>★★★★★</span>
                        </div>
                        <div className="empty-ratings">
                          <span>★★★★★</span>
                        </div>
                      </div>
                    </div>
                    <span className="rating-text">(80+ Clients Reviews)</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 order-lg-1">
              <div className="testimonial-wrapper wow fadeInUp" data-wow-delay=".5s">
                <div className="swiper testimonial-slider-2">
                  <div className="swiper-wrapper">
                    {testimonials.map((testimonial, index) => (
                      <div key={index} className="swiper-slide">
                        <div className="testimonial-item">
                          <span className="quote-icon"><i className="fas fa-quote-right"></i></span>
                          <div className="desc">
                            <p>{testimonial.text}</p>
                          </div>
                          <div className="testimonial-author">
                            <div className="author-inner">
                              <div className="author-img">
                                <img src={testimonial.image} alt="" />
                              </div>
                              <div className="author-header">
                                <h4 className="title">{testimonial.name}</h4>
                                <span className="designation">{testimonial.role}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="swiper-pagination-area"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="tj-team-section-3 section-gap section-gap-x">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="sec-heading text-center">
                <span className="sub-title wow fadeInUp" data-wow-delay=".3s">
                  <i className="fas fa-box"></i> Meet Our Team
                </span>
                <h2 className="sec-title title-anim">Success <span>Stories</span> Fuel our Innovation.</h2>
              </div>
            </div>
          </div>
          <div className="row leftSwipeWrap">
            {teamMembers.map((member, index) => (
              <div key={index} className="col-lg-3 col-sm-6">
                <div className="team-item left-swipe">
                  <div className="team-img">
                    <div className="team-img-inner">
                      <img src={member.image} alt="" />
                    </div>
                    <div className="social-links">
                      <ul>
                        <li><a href="https://www.facebook.com/" target="_blank" rel="noreferrer"><i className="fa-brands fa-facebook-f"></i></a></li>
                        <li><a href="https://www.instagram.com/" target="_blank" rel="noreferrer"><i className="fa-brands fa-instagram"></i></a></li>
                        <li><a href="https://x.com/" target="_blank" rel="noreferrer"><i className="fa-brands fa-x-twitter"></i></a></li>
                        <li><a href="https://www.linkedin.com/" target="_blank" rel="noreferrer"><i className="fa-brands fa-linkedin-in"></i></a></li>
                      </ul>
                    </div>
                  </div>
                  <div className="team-content">
                    <h4 className="title"><a href="#">{member.name}</a></h4>
                    <span className="designation">{member.role}</span>
                    <a className="mail-at" href="mailto:info@bexon.com"><i className="fas fa-at"></i></a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-shape-1">
          <img src="assets/images/shape/pattern-2.svg" alt="" />
        </div>
        <div className="bg-shape-2">
          <img src="assets/images/shape/pattern-3.svg" alt="" />
        </div>
      </section>

      {/* FAQ Section */}
      <section className="tj-faq-section section-gap">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-lg-4">
              <div className="content-wrap">
                <div className="sec-heading">
                  <span className="sub-title wow fadeInUp" data-wow-delay=".3s">
                    <i className="fas fa-box"></i>Common Questions
                  </span>
                  <h2 className="sec-title title-anim">Need <span>Help?</span> Start Here...</h2>
                </div>
                <p className="desc wow fadeInUp" data-wow-delay=".6s">
                  We stay ahead of curve, leveraging <br /> cutting-edge are technologies and <br /> strategies to competitive
                </p>
                <div className="wow fadeInUp" data-wow-delay=".8s">
                  <a className="tj-primary-btn" href="/contact">
                    <span className="btn-text"><span>Request a Call</span></span>
                    <span className="btn-icon"><i className="fas fa-arrow-right"></i></span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="accordion tj-faq" id="faqOne">
                {faqs.map((faq, index) => (
                  <div key={faq.id} className={`accordion-item ${activeAccordion === faq.id ? 'active' : ''} wow fadeInUp`} data-wow-delay={`.${3 + index}s`}>
                    <button
                      className={`faq-title ${activeAccordion === faq.id ? '' : 'collapsed'}`}
                      type="button"
                      onClick={() => toggleAccordion(faq.id)}
                      aria-expanded={activeAccordion === faq.id}
                    >
                      {faq.question}
                    </button>
                    <div className={`collapse ${activeAccordion === faq.id ? 'show' : ''}`}>
                      <div className="accordion-body faq-text">
                        <p>{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

     
    </main>
  );
}

export default About
